import { ReactNode } from "react";
import { atom } from "recoil";
import { PermissionEnum } from "types/enums";

import type { AnyRoute } from "@tanstack/react-router";

interface HeaderNavigationState {
    saveFormId: string | null;
    onDelete?: (() => void) | null;
    deleteLoading?: boolean;
    editLink: HeaderNavigationEditLink | null;
    detailLink: HeaderNavigationDetailLink | null;
    items: HeaderNavigationItem[];
    isEdit?: boolean;
    extraButtons?: ReactNode;
}

export interface HeaderNavigationItem {
    route: AnyRoute;
    customLabel?: string;
    // Overrides the route's own staticData.permissions for this tab's visibility only —
    // lets a route stay reachable/visible elsewhere (e.g. side menu) while hiding just this tab.
    requiredPermissions?: PermissionEnum[];
}

export interface HeaderNavigationEditLink {
    to: string;
    params: { [key: string]: string };
    search?: { [key: string]: string };
}

export interface HeaderNavigationDetailLink {
    to: string;
    params: { [key: string]: string };
    search?: { [key: string]: string };
    label?: string;
}

export const headerNavigationAtom = atom<HeaderNavigationState>({
    key: "headerNavigationAtom",
    default: {
        saveFormId: null,
        editLink: null,
        detailLink: null,
        items: [],
        isEdit: false,
    },
});
